// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"24564434","415":"24564434","842":"24564434","844":"24564434"}[chunkId] + ".chunk.css";
};